import { DOMAINS } from "./links";
import { webPaths } from "../utils/screenPathCreator";

/** Imprint data for customer-facing e-mails (§ 5 DDG). */
export const MAIL_LEGAL_IMPRINT = {
  companyName: "Johannes Förster Entspannungshelden",
  streetAddress: "Motzstraße 2B",
  postalCode: "34117",
  city: "Kassel",
  country: "Deutschland",
  representative: "Johannes Förster (Inhaber)",
  vatId: "DE365263562",
} as const;

const buildWebsiteUrl = (path: string): string => `${DOMAINS.WEBSITE}${path}`;

/** Absolute URLs to legal pages linked from transactional customer e-mails. */
export const MAIL_LEGAL_URLS = {
  imprint: buildWebsiteUrl(webPaths.getImprintPath()),
  privacy: buildWebsiteUrl(webPaths.getDataProtectionPath()),
  terms: buildWebsiteUrl(webPaths.getTermsPath()),
  disclaimer: buildWebsiteUrl(webPaths.getDisclaimerPath()),
} as const;

export const getMailLegalBranding = (): {
  companyName: string;
  companyAddressLine: string;
  companyRepresentative: string;
  vatId: string;
  imprintUrl: string;
  privacyUrl: string;
  termsUrl: string;
  disclaimerUrl: string;
} => ({
  companyName: MAIL_LEGAL_IMPRINT.companyName,
  companyAddressLine: `${MAIL_LEGAL_IMPRINT.streetAddress}, ${MAIL_LEGAL_IMPRINT.postalCode} ${MAIL_LEGAL_IMPRINT.city}, ${MAIL_LEGAL_IMPRINT.country}`,
  companyRepresentative: MAIL_LEGAL_IMPRINT.representative,
  vatId: MAIL_LEGAL_IMPRINT.vatId,
  imprintUrl: MAIL_LEGAL_URLS.imprint,
  privacyUrl: MAIL_LEGAL_URLS.privacy,
  termsUrl: MAIL_LEGAL_URLS.terms,
  disclaimerUrl: MAIL_LEGAL_URLS.disclaimer,
});
